<script setup>
import {useIsMobile} from "~/composables/useIsMobile";

const config = useRuntimeConfig()

const emit = defineEmits(['logout'])
const props = defineProps({
  items: {
    type: Array,
    default: () => []
  }
})

const isMobile = useIsMobile()
const menuRef = ref(null)
const currentSubmenu = ref(null)

function hasSubitems(item) {
  console.info(item)
  return item?.items?.length > 0
}

function mustShowItemIcon(item) {
  return ['icon', 'icon_text'].includes(item.type) && item.icon
}

function getItemLink(item) {
  return item?.url || '#'
}

function getItemLinkTarget(item) {
  if(!item.url) return null

  return (item.url.startsWith('http') && !item.url.includes(config.public.hostname)) ? '_blank' : null
}

function showSubmenu(submenuName) {
  if (!currentSubmenu) return
  console.info("show submenu")
  if (currentSubmenu.value) {
    const itemRef = document.querySelector(`#${currentSubmenu.value}`)

    itemRef.classList.remove('block')
    itemRef.classList.add('hidden')
  }

  if (!submenuName) return
  const itemRef = document.querySelector(`#${submenuName}`)

  if (itemRef.classList.contains('hidden')) {
    itemRef.classList.remove('hidden')
    itemRef.classList.add('block')

    currentSubmenu.value = submenuName
  } else {
    itemRef.classList.remove('block')
    itemRef.classList.add('hidden')

    currentSubmenu.value = null
  }
}

function doLogout() {
  emit('logout')
}

watch(() => isMobile.value, (newValue, oldValue) => {
  if (!newValue && oldValue) {
    menuRef.value?.hide()
  }
})
</script>

<template>
  <div v-if="props.items" class="flex flex-col">
    <template v-for="(item, index) in props.items" :key="`mobile-menu-item-${index}`">
      <div class="flex flex-col mb-2 text-[#363330]">
        <a v-if="hasSubitems(item)" class="flex items-center italic mb-1 font-bold" href="#"
           @click.prevent="showSubmenu(hasSubitems(item)?`mobile-menu-item-${index}`:null)"
        >
          <i v-if="mustShowItemIcon(item)" class="flex items-center mr-2" :class="item.icon"/>
          <span>{{ item.label }}</span>
          <i class="pi pi-angle-down ml-1 flex items-center"/>
        </a>
        <NuxtLink
          v-else
          class="flex items-center italic mb-1 font-bold"
          :to="getItemLink(item)"
          :target="getItemLinkTarget(item)"
        >
          <i v-if="mustShowItemIcon(item)" class="flex items-center mr-2" :class="item.icon"/>
          <span>{{ item.label }}</span>
        </NuxtLink>
        <div v-if="hasSubitems(item)" :id="`mobile-menu-item-${index}`"
             class="flex flex-col mb-2 ml-5 hidden border-l border-l-gray-400 gap-2">
          <NuxtLink v-for="subitem in item.items" :key="`mobile-submenu-item-${index}`" class="italic text-sm pl-1"
                    :to="getItemLink(subitem)">
            <i v-if="mustShowItemIcon(subitem)" class="flex items-center mr-2" :class="subitem.icon"/>
            <span>{{ subitem.label }}</span>
          </NuxtLink>
        </div>
      </div>
    </template>
    <div class="flex justify-center inline gap-4 my-4 text-[#363330]">
      <NuxtLink to="https://wa.me/+34687740145?text=Hola%20Diprofem" target="_blank"><i class="pi pi-whatsapp mr-0 text-2xl"></i></NuxtLink>
      <NuxtLink to="https://www.facebook.com/diprofem" target="_blank"><i class="pi pi-facebook mr-0 text-2xl"></i></NuxtLink>
      <NuxtLink to="https://www.instagram.com/diprofem" target="_blank"><i class="pi pi-instagram text-2xl"></i></NuxtLink>
      <NuxtLink to="https://www.youtube.com/channel/UCY7XsIlfdw2tiCoR5jyhrQg/featured" target="_blank"><i class="pi pi-youtube text-2xl"></i></NuxtLink>
    </div>
    <!--
    <div class="text-sm italic rounded mt-4">
      <button class="text-center text-white bg-teal-600 p-2 w-full rounded" @click="doLogout">Cerrar Sesión
      </button>
    </div>
    -->
  </div>
</template>

